import React from 'react';
import { Header } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { Breadcrumb } from './Breadcrumb';
import { Heading } from './Heading';
import { Description } from './Description';
import { ProductGrid } from './ProductGrid';
/**
 * Wacoku Products category page (/shop/wacoku-products/).
 *
 * Self-contained: every section lives in `./` and is owned by this page only.
 */
export function WacokuProductsPage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-973">
      <Header data-id="element-974" />
      <main className="flex-grow pt-32 pb-20" data-id="element-975">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-976">
          <Breadcrumb data-id="element-977" />
          <Heading data-id="element-978" />
          <Description data-id="element-979" />
          <ProductGrid data-id="element-980" />
        </div>
      </main>
      <Footer data-id="element-981" />
    </div>;
}